import { Box, Button, Dialog, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

// Asked the moment the business-details window closes. The form inside that
// window belongs to the payment provider and tells us nothing — not whether it
// was sent, not whether it was abandoned halfway — so the only one who knows is
// the supplier, and we ask.
//
// The two buttons are the only way out: no X, and neither a click outside nor
// Escape closes it. Whatever the supplier answers is what moves them on, and an
// answer that isn't true is theirs to live with.

const styles = {
  paper: { borderRadius: "12px", width: "360px", padding: "24px 20px 20px" },
  title: {
    fontSize: "16px",
    fontWeight: 600,
    color: "rgba(62, 63, 76, 1)",
    textAlign: "center",
  },
  actions: { display: "flex", flexDirection: "column", gap: "8px", marginTop: "20px" },
  yes: {
    backgroundColor: "rgba(37, 124, 109, 1)",
    color: "#fff",
    borderRadius: "8px",
    padding: "8px 16px",
    fontSize: "15px",
    fontWeight: 500,
    textTransform: "none",
    boxShadow: "none",
    "&:hover": { backgroundColor: "rgba(37, 124, 109, 1)", boxShadow: "none" },
  },
  no: {
    color: "rgba(62, 63, 76, 0.9)",
    border: "1px solid rgba(212, 212, 212, 1)",
    borderRadius: "8px",
    padding: "8px 16px",
    fontSize: "15px",
    fontWeight: 500,
    textTransform: "none",
  },
};

const KycFormDoneDialog = ({ open, onDone, onLater }) => {
  const { t } = useTranslation("supplier-kyc");

  return (
    <Dialog
      open={open}
      onClose={undefined}
      disableEscapeKeyDown
      PaperProps={{ sx: styles.paper }}
    >
      <Typography sx={styles.title}>{t("details.done_question.title")}</Typography>
      <Box sx={styles.actions}>
        <Button variant="contained" sx={styles.yes} onClick={onDone}>
          {t("details.done_question.yes")}
        </Button>
        <Button variant="outlined" sx={styles.no} onClick={onLater}>
          {t("details.done_question.no")}
        </Button>
      </Box>
    </Dialog>
  );
};

export default KycFormDoneDialog;
